// vue3-migration -- Element
import langHe from 'element-plus/es/locale/lang/he';
import translations from './translations.json';
import 'moment/locale/he';

export default {
  ...translations,
  // vue3-migration -- Element
  ...langHe,
};
